module.exports = __webpack_public_path__ + "assets/img/2021-11.468d3282.png";